module.exports = __webpack_public_path__ + "img/carnival-right.bcce5473.png";